import(/* webpackMode: "eager" */ "/app/src/app/[locale]/about-us/page.tsx");
